import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 286.054 286.054",
  style: {"enable-background":"new 0 0 286.054 286.054"},
  "xml:space": "preserve"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M143.027 0C64.031 0 0 64.04 0 143.027c0 78.996 64.031 143.027 143.027 143.027s143.027-64.031 143.027-143.027C286.054 64.04 222.022 0 143.027 0zm0 259.236c-64.183 0-116.209-52.026-116.209-116.209S78.844 26.818 143.027 26.818s116.209 52.026 116.209 116.209-52.026 116.209-116.209 116.209z" }),
      _createElementVNode("path", { d: "M150.026 80.39h-22.84c-6.91 0-10.933 7.044-10.933 13.158 0 5.936 3.209 13.158 10.933 13.158h7.259v85.36c0 8.734 6.257 13.605 13.176 13.605s13.185-4.881 13.185-13.605V92.771c-.008-6.982-3.861-12.381-10.78-12.381z" })
    ], -1)
  ]))]))
}
export default { render };